import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Constants from "../../Constants/Constants";

export const getStats = createAsyncThunk(
  "stats/all",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`${Constants.apiUrl}/stats/all`);
      return data;
    } catch (err: any) {
      if (err?.response?.data) {
        return rejectWithValue(err?.response?.data);
      } else {
        return rejectWithValue(err);
      }
    }
  }
);

export const getFeedbackChart = createAsyncThunk(
  "stats/feedback-chart",
  async (
    params: { startDate: Date | null; endDate: Date | null },
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axios.post(
        `${Constants.apiUrl}/stats/feedback-chart`,
        params
      );

      return data;
    } catch (err: any) {
      if (err?.response?.data) {
        return rejectWithValue(err?.response?.data);
      } else {
        return rejectWithValue(err);
      }
    }
  }
);

export const getFeedbackChartByNumber = createAsyncThunk(
  "stats/feedback-chart-by-number",
  async (
    params: { startDate: Date | null; endDate: Date | null } | undefined,
    { rejectWithValue }
  ) => {
    try {
      const { data } = await axios.post(
        `${Constants.apiUrl}/stats/feedback-chart-by-number`,
        params
      );
      return data;
    } catch (err: any) {
      if (err?.response?.data) {
        return rejectWithValue(err?.response?.data);
      } else {
        return rejectWithValue(err);
      }
    }
  }
);

export const getSearchLogs = createAsyncThunk(
  "stats/search-logs",
  async (search: string, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${Constants.apiUrl}/stats/search-logs`,
        { search }
      );
      return data;
    } catch (err: any) {
      if (err?.response?.data) {
        return rejectWithValue(err?.response?.data);
      } else {
        return rejectWithValue(err);
      }
    }
  }
);

export const getEmailLogs = createAsyncThunk(
  "stats/email-logs",
  async (email: string, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(
        `${Constants.apiUrl}/stats/email-logs`,
        { email }
      );
      return data;
    } catch (err: any) {
      if (err?.response?.data) {
        return rejectWithValue(err?.response?.data);
      } else {
        return rejectWithValue(err);
      }
    }
  }
);

export const getJobList = createAsyncThunk(
  "stats/job-list",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios.post(`${Constants.apiUrl}/stats/job-list`);
      return data;
    } catch (err: any) {
      if (err?.response?.data) {
        return rejectWithValue(err?.response?.data);
      } else {
        return rejectWithValue(err);
      }
    }
  }
);
